import { PayrollRunStatus } from '../types';

interface BadgeSpec {
  label: string;
  className: string;
  /** Decorative glyph — status is always conveyed by the text label as well, never by color alone. */
  glyph: string;
}

const BADGES: Record<string, BadgeSpec> = {
  [PayrollRunStatus.Draft]: { label: 'Draft', className: 'badge badge--neutral', glyph: '✎' },
  [PayrollRunStatus.PendingApproval]: { label: 'Pending approval', className: 'badge badge--pending', glyph: '◷' },
  [PayrollRunStatus.Approved]: { label: 'Approved', className: 'badge badge--approved', glyph: '✓' },
  [PayrollRunStatus.Rejected]: { label: 'Rejected', className: 'badge badge--rejected', glyph: '✕' },
  [PayrollRunStatus.Withdrawn]: { label: 'Withdrawn', className: 'badge badge--neutral', glyph: '↩' },
};

/** The one place a Module 7 payroll-run status becomes UI. An unknown (future) status is shown as its raw text
 * in a neutral badge rather than hidden or mislabeled; null/undefined (e.g. a Custom Pay Run not handed off
 * yet) renders an em dash. */
export function PayrollRunStatusBadge({ status }: { status: string | null | undefined }) {
  if (!status) return <span className="muted">—</span>;
  const spec = BADGES[status] ?? { label: status, className: 'badge badge--neutral', glyph: '•' };
  return (
    <span className={spec.className} data-status={status}>
      <span aria-hidden="true">{spec.glyph} </span>
      {spec.label}
    </span>
  );
}
